import { Skeleton } from "@mui/material";
import { ImageGridItem, SkeletonStyled } from "../styles";

interface ImageGridSkeletonProps {
  count?: number;
}

const ImageGridSkeleton = ({ count = 7 }: ImageGridSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ImageGridItem key={`skeleton-${index}`}>
          <SkeletonStyled variant="rectangular" width="100%" height="170px" />
        </ImageGridItem>
      ))}
    </>
  );
};

export default ImageGridSkeleton;
